(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/core-js/object/values', 'babel-runtime/helpers/extends', 'babel-runtime/helpers/classCallCheck', 'babel-runtime/helpers/possibleConstructorReturn', 'babel-runtime/helpers/inherits', 'react', 'prop-types', 'react-redux', 'animejs', './levels', './Notification.css'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/core-js/object/values'), require('babel-runtime/helpers/extends'), require('babel-runtime/helpers/classCallCheck'), require('babel-runtime/helpers/possibleConstructorReturn'), require('babel-runtime/helpers/inherits'), require('react'), require('prop-types'), require('react-redux'), require('animejs'), require('./levels'), require('./Notification.css'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.values, global._extends, global.classCallCheck, global.possibleConstructorReturn, global.inherits, global.react, global.propTypes, global.reactRedux, global.animejs, global.levels, global.Notification);
    global.Notification = mod.exports;
  }
})(this, function (exports, _values, _extends2, _classCallCheck2, _possibleConstructorReturn2, _inherits2, _react, _propTypes, _reactRedux, _animejs, _levels, _Notification) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Notification = undefined;

  var _values2 = _interopRequireDefault(_values);

  var _extends3 = _interopRequireDefault(_extends2);

  var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

  var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

  var _inherits3 = _interopRequireDefault(_inherits2);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _animejs2 = _interopRequireDefault(_animejs);

  var _levels2 = _interopRequireDefault(_levels);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Notification = exports.Notification = function (_React$Component) {
    (0, _inherits3.default)(Notification, _React$Component);

    function Notification(props) {
      (0, _classCallCheck3.default)(this, Notification);

      var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));

      _this.onClose = function () {
        var elementId = _this.state.elementId;

        _animejs2.default.timeline().add((0, _extends3.default)({
          targets: elementId,
          opacity: _this.props.inline ? 1 : 0,
          easing: _this.props.inline ? 'linear' : 'easeOutExpo'
        }, _Notification.animateOut1)).add((0, _extends3.default)({ targets: elementId }, _Notification.animateOut2)).finished.then(_this.onCloseAnimationFinish);
      };

      _this.onCloseAnimationFinish = function () {
        // const el = document.querySelector(selector);
        _this.setState({ visible: false });
        // if (el) el.style.display = 'none';

        if (_this.props.dismissNotification) _this.props.dismissNotification(_this.state.id);
      };

      _this.state = {
        visible: props.message && props.level && props.id,
        elementId: '#pjp-notification-' + props.id
      };
      return _this;
    }

    Notification.prototype.componentDidMount = function componentDidMount() {
      (0, _animejs2.default)((0, _extends3.default)({ targets: this.state.elementId }, _Notification.animateIn));
      //  if timeout set to true or not set - notification will dismiss in 4seconds
      if (this.props.timeOut === false || this.props.level === _levels2.default.error || this.props.level === _levels2.default.warn) {
        return;
      }

      this.timeout = window.setTimeout(this.onClose, 4000);
    };

    Notification.prototype.componentWillUnmount = function componentWillUnmount() {
      clearTimeout(this.timeout);
    };

    Notification.prototype.render = function render() {
      var _levels$error$levels$;

      var _props = this.props,
          level = _props.level,
          message = _props.message,
          id = _props.id,
          isShowingIcon = _props.isShowingIcon,
          timeOut = _props.timeOut,
          messageLabel = _props.messageLabel;

      if (!this.state.visible) return _react2.default.createElement('span', null);

      var elementId = 'pjp-notification-' + id;

      return _react2.default.createElement(
        _Notification.NotificationBox,
        {
          id: elementId,
          level: level,
          isShowingIcon: isShowingIcon,
          timeOut: timeOut
        },
        (_levels$error$levels$ = {}, _levels$error$levels$[_levels2.default.error] = _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(
            'span',
            { className: _Notification.titlePrefixClass },
            messageLabel || 'Error!'
          ),
          _react2.default.createElement(
            'span',
            null,
            message
          ),
          isShowingIcon && _react2.default.createElement(
            'span',
            {
              className: 'material-icons button-close',
              onClick: this.onClose,
              onKeyPress: this.onClose,
              role: 'button',
              tabIndex: '0'
            },
            'close'
          )
        ), _levels$error$levels$[_levels2.default.info] = _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(
            'span',
            { className: _Notification.titlePrefixClass },
            messageLabel || 'Info:'
          ),
          _react2.default.createElement(
            'span',
            null,
            message
          ),
          isShowingIcon && _react2.default.createElement(
            'span',
            {
              className: 'material-icons button-close',
              onClick: this.onClose,
              onKeyPress: this.onClose,
              role: 'button',
              tabIndex: '0'
            },
            'close'
          )
        ), _levels$error$levels$[_levels2.default.warn] = _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(
            'span',
            { className: _Notification.titlePrefixClass },
            messageLabel || 'Warn:'
          ),
          _react2.default.createElement(
            'span',
            null,
            message
          ),
          isShowingIcon && _react2.default.createElement(
            'span',
            {
              className: 'material-icons button-close',
              onClick: this.onClose,
              onKeyPress: this.onClose,
              role: 'button',
              tabIndex: '0'
            },
            'close'
          )
        ), _levels$error$levels$[_levels2.default.success] = _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(
            'span',
            { className: _Notification.titlePrefixClass, style: { marginRight: 5 } },
            messageLabel || 'Success!'
          ),
          _react2.default.createElement(
            'span',
            null,
            message
          ),
          isShowingIcon && _react2.default.createElement(
            'span',
            {
              className: 'material-icons button-close',
              onClick: this.onClose,
              onKeyPress: this.onClose,
              role: 'button',
              tabIndex: '0'
            },
            'close'
          )
        ), _levels$error$levels$)[level]
      );
    };

    return Notification;
  }(_react2.default.Component);

  Notification.defaultProps = {
    isShowingIcon: true
  };
  exports.default = Notification;


  Notification.propTypes = {
    id: _propTypes2.default.string.isRequired,
    level: _propTypes2.default.oneOf((0, _values2.default)(_levels2.default)).isRequired,
    message: _propTypes2.default.string.isRequired,
    messageLabel: _propTypes2.default.string, // override instead of Info, Warn, etc.
    onClose: _propTypes2.default.func,
    dismissNotification: _propTypes2.default.func,
    inline: _propTypes2.default.bool,
    isShowingIcon: _propTypes2.default.bool,
    timeOut: _propTypes2.default.bool
  };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Notifications/Notification.js
// module id = 1151
// module chunks = 0